import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationLogoComponent } from './organization-logo.component';
import { ImageEditorModule } from '../image-editor/image-editor.module';
import { ButtonModule } from '../../../shared/button/button.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        NgbModule,
        ImageEditorModule,
        ButtonModule,
        MatProgressSpinnerModule,
    ],
    exports: [OrganizationLogoComponent],
    declarations: [OrganizationLogoComponent],
    providers: [],
})
export class OrganizationLogoModule
{
}
